export default __webpack_public_path__ + "static/media/Roboto-Bold.672d09d3.woff2";